module.exports = __webpack_public_path__ + "static/media/sup_pla_equ.73a774dc.png";